export const SET_VIDEO_SETTINGS_DATA = "SET_VIDEO_SETTINGS_DATA";
